import React from "react";

const currency =
  typeof window !== "undefined" && window.___APP_CONFIG___
    ? window.___APP_CONFIG___.DATA_TYPE_DECIMALS.CURRENCY
    : "";

const price =
  typeof window !== "undefined" && window.___APP_CONFIG___
    ? window.___APP_CONFIG___.DATA_TYPE_DECIMALS.PRICE
    : "";

const quantity =
  typeof window !== "undefined" && window.___APP_CONFIG___
    ? window.___APP_CONFIG___.DATA_TYPE_DECIMALS.QUANTITY
    : "";

const percentage =
  typeof window !== "undefined" && window.___APP_CONFIG___
    ? window.___APP_CONFIG___.DATA_TYPE_DECIMALS.PERCENTAGE
    : "";

const defaultValue =
  typeof window !== "undefined" && window.___APP_CONFIG___
    ? window.___APP_CONFIG___.DATA_TYPE_DECIMALS.DEFAULT
    : "";

const decimalAmount = {
  quantity: quantity,
  price: price,
  currency: currency,
  percentage: percentage,
  default: defaultValue,
};

export function FormatNumber({ value, dataTypeDecimalName, decimalScale = null }) {
  dataTypeDecimalName = dataTypeDecimalName.toString().toLowerCase();

  return Number(parseFloat(value).toFixed(2)).toLocaleString(
    "en",
    { minimumFractionDigits: decimalScale ? decimalScale : decimalAmount[dataTypeDecimalName] },
    { maximumFractionDigits: decimalScale ? decimalScale : decimalAmount[dataTypeDecimalName] }
  );
}

export function truncateNumber(num, fixed) {
  var re = new RegExp("^-?\\d+(?:.\\d{0," + (fixed || -1) + "})?");
  return num.toString().match(re)[0];
}
